module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/trips/close-trips/close-trips.component.css
// module id = ./src/app/trips/close-trips/close-trips.component.css
// module chunks = main